import React from 'react';
import styled from 'styled-components';
import Flex from './Flex';

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: ${props => props.w || '150px'};
  background: #fff;
  border-radius: 24px;
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(1);
  }
`;

const GradientText = styled.p`
  height: 19px;
  font-weight: 600;
  font-size: 16px;
  background: linear-gradient(90deg, #0284ff, #9b39fc, #f41efc, #ff8f35);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const GradientButton = ({ onClick, text, w }) => (
  <Button w={w} onClick={onClick}>
    <GradientText>{text}</GradientText>
    <Flex w="7px" />
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L6.25 6.25L1 11.5"
        stroke="#FE8742"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Button>
);

export default GradientButton;
